module.exports = __webpack_public_path__ + "static/img/image_charge.9ff75321.gif";